<div class="row title-container align-items-center mb-5" style="padding: 10px;">
    <img src="./assets/icons/arrow.svg">
    <span class="label-title ml-2 mr-3">Adicionar favorecidos</span>
</div>
<div class="row cards">
    <div class="col-md-12 text-right" *ngIf="!isMobile">

        <ul class="options-cadastro">
            <li>
                <div *ngIf="exibirFiltro && filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                    my-1">
                    <button _ngcontent-khv-c20="" class="list-select-delete" type="button">
                        Apagar filtro
                    </button>
                </div>
            </li>
            <li>
                <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                    my-1">
                    <button _ngcontent-khv-c20="" class="list-select"  type="button">
                        <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                        <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                    </button>
                </div>
            </li>
            <li>
                <div class="list-select-search-input ml-2 my-1">
                    <input class="w-100 ng-untouched ng-pristine
                        ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="callCollaboradores(1)" autocomplete="off"/>
                </div>
            </li>
            <li>
                <div class="list-filter-show-item ml-2 my-1">
                    Mostrar:
                    <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                        <option _ selected="" value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </li>
        </ul>
    </div>
    <div class="title">
        <span class="color">Atribuir o produto aos favorecidos</span>
        <span class="color right">{{ countSelectedItens }} de {{ totalRegister }} favorecidos selecionados</span>
    </div>
    <div class="container espacamento">
        <!-- <div class="espacamento">
            <input name="busca" id="busca" [(ngModel)]="valorBusca" type="text" class="form-control textbox-n input-font-size h-auto" placeholder="Busca">
        </div>
        <div class="espacamento">
            <button class="action-button">Filtrar</button>
        </div>
        <div class="espacamento">
            <button class="white-button">Limpar filtros</button>
        </div> -->
        <span *ngIf="!selectAll" class="color" style="align-self: center; cursor: pointer;" (click)="selecionarTodos()">Selecionar todos</span>
        <span *ngIf="selectAll" class="color" style="align-self: center; cursor: pointer;" (click)="selecionarTodos()">Desmarcar todos</span>
    </div>
    <div style="margin: 30px 0 15px 15px; display: block;" class="title">
        <div *ngFor="let item of colaboradores | paginate: { id: 'pagination', itemsPerPage: showItem, currentPage: page, totalItems: totalRegister } " class="row container-dados" style="position: relative;" >
            <input class="custom sel" style="margin-right: 30px;" [checked]="selectAll ? !item.selected : item.selected" (change)="selectElement(item)" type="checkbox" id={{item.id}} [disabled]="item.grupo==group.guidID ">
            <div class="identificador"> <p class="identificador-letra"> {{ item.nome.charAt(0) }} </p> </div>
            <div class="colaborador-info">
                <span style="font-weight: 510;">{{ item.nome }}</span>
                <span *ngIf="item.grupoNome!=''" class="color p-0">Grupo {{ item.grupoNome }}</span>
                <span style="font-size: 10px;">CPF: {{ item.cpf | cpf }}</span>
            </div>
            <div class="title" style="margin-bottom: 10px;">
                <hr />
            </div>
        </div>
        <div class="page-custom">
            <pagination-controls id="pagination" responsive="true" previousLabel="" nextLabel="" (pageChange)="callCollaboradores($event)"></pagination-controls>
        </div>
    </div>
    <div class="title" style="padding-top: 30px;">
        <button class="action-button finalizar-button right" (click)="onSumit(finalModal)" >Finalizar</button>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field class="example-form-field">
                    <input [formControl]="nameCtrl" matInput type="text" placeholder="Nome">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                    </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field class="example-form-field">
                    <input [formControl]="documentCtrl"  matInput type="text" placeholder="CPF">
                    <button mat-button *ngIf="filtroCPF" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCPF=''">
                        <mat-icon>close</mat-icon>
                    </button>
                    </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field class="example-form-field">
                    <input [formControl]="registerCtrl" matInput type="text" placeholder="{{ labelMatricula }}">
                    <button mat-button *ngIf="filtroMatricula" matSuffix mat-icon-button aria-label="Clear" (click)="filtroMatricula=''">
                        <mat-icon>close</mat-icon>
                    </button>
                    </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="costCenterCtrl" id="centroCusto" [multiple]="true" placeholder="{{ labelCentroCusto }}" [value]="filtroCentroCusto">
                        <mat-option *ngFor="let item of centrosCustosList" [value]="item.centroCustoId">
                            {{item.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="unitCtrl" id="unidade" [multiple]="true" placeholder="{{ labelUnidade }}" [value]="filtroUnidade">
                        <mat-option *ngFor="let item of unidadesList" [value]="item.unidadeId">
                            {{item.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="departmentCtrl" id="departamento" [multiple]="true" placeholder="{{ labelDepartamento }}" [value]="filtroDepartamento">
                        <mat-option *ngFor="let item of departamentosList" [value]="item.departamentoId">
                            {{item.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="
                applyFilter();
                modal.dismiss('Close click')
            " ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>

<!--Modal do final-->
<ng-template #finalModal let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">Adicionar ao grupo</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <p class="text-center">
                {{totalCola}} favorecidos selecionados pertecem à outro(s) grupo(s)<br>Deseja continuar?
            </p>
            <div class="mx-5">
                <ng-container *ngFor="let item of colaboradoresSelecionados | paginate: { id: 'pagination', itemsPerPage: qtdItensPerPage, currentPage: page, totalItems: totalRegister }">
                    <div *ngIf="item.grupo!=group.guidID &&  item.grupo!=''" class="row container-dados" style="position: relative;" >
                        <input *ngIf="item.grupo!=group.guidID " class="custom sel" style="margin-right: 30px;" [checked]="item.selected" (change)="selectElement(item);atualizaModal(finalModal)" type="checkbox" id={{item.id}}>
                        <div class="colaborador-info">
                            <span style="font-weight: 510;">{{ item.nome }}
                            <span *ngIf="item.grupoNome!=''" class="color pl-1">Grupo {{ item.grupoNome }}</span>
                        </span>
                            <span style="font-size: 10px;">CPF: {{ item.cpf | cpf }}</span>
                        </div>
                        <div class="title" style="margin-bottom: 10px;">
                            <hr class="mb-0"/>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="col-12 modal-footer clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')">
            Cancelar
        </button>
        <button class="custom-modal-button" (click)="finalizar();modal.dismiss('Close click')">
            Adicionar
        </button>
    </div>
</ng-template>

<ng-template #confirmacao let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">Estamos configurando o grupo</h5>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <p class="clean-modal-title text-center">
            Levará aproximadamente cerca de {{ (collaboratorsId.length < 6) ? (collaboratorsId.length*10) + " segundos" : (((collaboratorsId.length*10)/60)| number:'1.2-2') + " minuto(s)"  }} para a configuração dos favorecidos ser concluída
        </p>
    </div>
    <div class="col-12 my-2 clean-modal-footer">
        <!-- <button class="custom-filter-button button-cancel mr-2" type="button" (click)="onCancel()"> Cancelar
        </button> -->
        <button class="custom-filter-button button-color-just" type="button" (click)="modal.dismiss('Close click')">
            Ok
        </button>
    </div>
</ng-template>
